import React from 'react';

interface FeedbackIconProps {
  isCorrect: boolean;
}

const FeedbackIcon: React.FC<FeedbackIconProps> = ({ isCorrect }) => {
  return (
    <span
      className={`inline-flex items-center justify-center w-8 h-8 rounded-full text-3xl font-bold transition-all duration-500 ${
        isCorrect ? 'bg-success text-white animate-bounce' : 'bg-incorrect text-white animate-shake'
      }`}
      aria-label={isCorrect ? 'Correct' : 'Incorrect'}
    >
      {isCorrect ? '✓' : '✗'}
    </span>
  );
};

export default FeedbackIcon;
